import type { FC } from "react";
import { SwiperComp } from "../../shared/components/SwiperComp/SwiperComp";
import classes from "./Team.module.scss";

export const Team: FC = () => {
	return (
		<div className={classes.wrapper}>
			<div className={classes.content}>
				<h2 className={classes.title}>Meet our team</h2>
				<span className={classes.text}>Smaller text below the title</span>
				<SwiperComp className={classes.swiper} />
			</div>
		</div>
	);
};
